export default __webpack_public_path__ + "static/media/aq.d469b891.svg";